WiseMetering.Views.NewSiteTag = WiseMetering.Views.Modal.Save.extend({
    className: 'mbx-info text-left',
    form_prefix: 'site_tag',
    template: 'templates/site_tags/new',
    title: () => i18next.t('modal.title.site_tags.new')
});
